import { UserfbDetailsComponent } from './views/pages/master/userfeedbackhistory/userfb-detail/userfb-detail.component';
import { BrowserModule } from "@angular/platform-browser";
import { NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { LayoutModule } from "./views/layout/layout.module";
import { AuthGuard } from "./core/guard/auth.guard";
import { AppComponent } from "./app.component";
import { ErrorPageComponent } from "./views/pages/error-page/error-page.component";
import { HIGHLIGHT_OPTIONS } from "ngx-highlightjs";
import { SharedModule } from "./shared/shared.module";
import { ToastrModule } from "ngx-toastr";
import {
  HttpClient,
  HttpClientModule,
  HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { AlertService } from "./services/alert.service";
import { AuthenticationService } from "./services/authentication.service";
import { DataService } from "./services/data.service";
import { HttpInterceptorService } from "./services/interceptor.service";
import { UserSessionService } from "./services/usersession.service";
// import { NgHttpLoaderModule } from 'ng-http-loader';
import { RoleService } from "./services/role.service";
import {
  OwlDateTimeModule,
  OwlNativeDateTimeModule,
  OWL_DATE_TIME_LOCALE,
} from "ng-pick-datetime";

import { UtilityService } from "./services/utility.service";

import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { NavigationService } from "./services/navigation.service";
import { ExcelService } from "./services/excel.service";
import { ReportsService } from "./services/reports.service";
import { NgbDropdownModule, NgbModule, NgbCarouselModule } from "@ng-bootstrap/ng-bootstrap";
import { LivetrackService } from "./services/livetrack.service";
import { LightboxModule } from "ngx-lightbox";
import { UserIdleModule } from "angular-user-idle";
import { OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS } from "ng-pick-datetime/date-time/adapter/moment-adapter/moment-date-time-adapter.class";
import { ShowDailyReportModule } from "./views/pages/reports/showdailyreport/showdailyreport.module";
import { ShowTripReportModule } from "./views/pages/reports/showtripreport/showtripreport.module";
import { ShowWeeklyReportModule } from "./views/pages/reports/showweeklyreport/showweeklyreport.module";
import { ShowMonthlyReportModule } from "./views/pages/reports/showmonthlyreport/showmonthlyreport.module";
import { ShowOutturnReportModule } from "./views/pages/reports/showoutturnreport/showoutturnreport.module";
import { ViewbookingComponent } from "./views/pages/mhire/cashbooking/viewbooking.component";
import { ShowBookingReportModule } from "./views/pages/reports/showbookingreport/showbookingreport.module";
import { MatButtonModule } from "@angular/material/button";
import { MatTableModule } from "@angular/material/table";
import { MatSortModule } from "@angular/material/sort";
import { MatPaginatorModule } from "@angular/material/paginator";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatDialogModule } from "@angular/material/dialog";
import { DirectivesModule } from "./views/layout/directives/directives.module";
import { MatSelectModule } from "@angular/material/select";
import { MatSelectFilterModule } from "mat-select-filter";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatMomentDateModule } from "@angular/material-moment-adapter";
import { MatNativeDateModule } from "@angular/material/core";
import { MatTooltipModule } from "@angular/material/tooltip";
import { DepartmentBookingService } from "./services/department.service";
import { MhiredemoComponent } from "./views/pages/mhire/mhiredemo/mhiredemo.component";
import { BlockService } from "./services/block.service";
import { ConsumableentrydialogComponent } from "./views/pages/rollcall/consumableentry/consumableentrydialog.component";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { VehicleService } from "./services/vehicle.service";
import { BookingfailedtraceComponent } from "./views/pages/mhire/bookingfailedtrace/bookingfailedtrace.component";
import { ShowBillReportModule } from "./views/pages/reports/showbillreport/showbillreport.module";
import { RemittedtreasuryreportComponent } from "./views/pages/reports/remittedtreasuryreport/remittedtreasuryreport.component";
import { ShowremittedtreasuryreportComponent } from "./views/pages/reports/showremittedtreasuryreport/showremittedtreasuryreport.component";
import { TreasuryremittedreportComponent } from "./views/pages/reports/treasuryremittedreport/treasuryremittedreport.component";
import { ShowtreasuryremittedreportComponent } from "./views/pages/reports/showtreasuryremittedreport/showtreasuryremittedreport.component";
import { BookingavailabilityComponent } from "./views/pages/mhire/bookingavailability/bookingavailability.component";
import { ShowDistrictWiseStatusReportComponent } from "./views/pages/reports/showdistrictwisestatusreport/showdistrictwisestatusreport.component";
import { ShowDistrictWiseStatusReportModule } from "./views/pages/reports/showdistrictwisestatusreport/showdistrictwisestatusreport.module";
import { ProductService } from "./services/product.service";
import { GenericValidator } from "./views/layout/validators/generic-validator";
import { ManufacturerService } from "./services/manufacturer.service";
import { DealerService } from "./services/dealer.service";
import { hodashboardService } from "./services/hodashboard.service";
import { ProductpopupComponent } from "./views/pages/dbt/product/productpopup/productpopup.component";
import { ManufacturerpopupComponent } from "./views/pages/dbt/manufacturer/manufacturerpopup/manufacturerpopup.component";
import { ProductinfopopupComponent } from "./views/pages/dbt/product/productinfopopup/productinfopopup.component";
import { NgMultiSelectDropDownModule } from "ng-multiselect-dropdown";
import { ManufacturerclarifypopupComponent } from "./views/pages/dbt/manufacturer/manufacturerclarifypopup/manufacturerclarifypopup.component";

import { MatTabsModule } from "@angular/material/tabs";
import { ManufacturerModule } from "./views/pages/dbt/manufacturer/manufacturer.module";
import { ProductModule } from "./views/pages/dbt/product/product.module";
import { TimelineComponent } from "./views/pages/dbt/manufacturer-detail/timeline/timeline.component";
import { UserfbTimelineComponent } from './views/pages/master/userfeedbackhistory/userfbtimelines/userfbtimeline.component';
import { ReturnAttachmentComponent } from './views/pages/master/vehicle/returnattachment.component';
import { ManufacturerLockPopupComponent } from './views/pages/dbt/homanufacturer/manufacturerLockpopup/manufacturerLockpopup.component';
import { UtilizationreportComponent } from './views/pages/reports/utilizationreport/utilizationreport.component';
import { ShowutilizationreportComponent } from './views/pages/reports/showutilizationreport/showutilizationreport.component';
import { MatTreeModule } from '@angular/material/tree';
import { ArchwizardModule } from 'angular-archwizard';
import { MatIconModule } from '@angular/material/icon';
import { MatRadioModule } from '@angular/material/radio';
import { RouterModule } from '@angular/router';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RealtimetrackingpopupComponent } from './views/pages/realtimetracking/realtimetrackingpopup/realtimetrackingpopup.component';
import { ManufacturerDetailComponent } from './views/pages/dbt/manufacturer-detail/manufacturer-detail.component';
import { AeefarmerpopupComponent } from './views/pages/aeefarmerbookingapproval/aeefarmerpopup/aeefarmerpopup.component';
import { DealerpremisesverificationpopupComponent } from './views/pages/aeefarmerbookingapproval/dealerpremisesverificationpopup/dealerpremisesverificationpopup.component';
import { FarmerService } from './services/farmer.service';
import { aeefarmerPopupModule } from './views/pages/aeefarmerbookingapproval/aeefarmerpaymentpopup/aeefarmerpaymentpopup.module';
import { subsidyReleaseToFarmerPopupModule } from './views/pages/aeefarmerbookingapproval/subsidyreleasetofarmerpopup/subsidyreleasetofarmerpopup.module';
import { dealerPremisesVerificationPopupModule } from './views/pages/aeefarmerbookingapproval/dealerpremisesverificationpopup/dealerpremisesverificationpopup.module';
import { eefarmerbookingpopupModule } from './views/pages/aeefarmerbookingapproval/eefarmerbookingpopup/eefarmerbookingpopup.module';
import { AeesendbackpopupComponent } from './views/pages/aeefarmerbookingapproval/aeesendbackpopup/aeesendbackpopup.component';
import { SendbacktodealerpopupComponent } from './views/pages/sendbacktodealerpopup/sendbacktodealerpopup.component';
import { DealerrejectpopupComponent } from './views/pages/dbt/dealer/dealerrejectpopup/dealerrejectpopup.component';
import { FarmertimelineComponent } from './views/pages/dbt/farmertimeline/farmertimeline.component';
import { FarmertimelineModule } from './views/pages/dbt/farmertimeline/farmertimeline.module';
import { ExemptionpopupComponent } from './views/pages/dbt/exemptionpopup/exemptionpopup.component';
import { AefarmerpaymentpopupComponent } from './views/pages/aefarmerbookingapproval/aefarmerpaymentpopup/aefarmerpaymentpopup.component';
import { DivisionlevelpopupComponent } from './views/pages/divisionlevelpopup/divisionlevelpopup.component';
import { SubdivisionlevelpopupComponent } from './views/pages/subdivisionlevelpopup/subdivisionlevelpopup.component';
import { VillagelevelpopupComponent } from './views/pages/villagelevelpopup/villagelevelpopup.component';
import { DivisionlevelDrillpopupComponent } from './views/pages/dbt/target/stateleveltargetlist/divisionlevelpopup/divisionlevelpopup.component';
import { SendbackpopupComponent } from './views/pages/sendbackpopup/sendbackpopup.component';
// import { ReviewreportComponent } from './views/pages/reports/reviewreport/reviewreport.component';
import { BeneficiaryreportComponent } from './views/pages/reports/beneficiaryreport/beneficiaryreport.component';
import { FeedbackpopupComponent } from './views/pages/gpsdashboard/feedbackpopup/feedbackpopup.component';
import { MachineryWiseReportModule } from './views/pages/reports/machinery-wise-report/machinery-wise-report.module';
import { WaitingListReportModule } from './views/pages/reports/waiting-list-report/waiting-list-report.module';
import { PaacsComponent } from './views/pages/paacs/paacs.component';
import { PaccsbookingService } from './services/paccsbooking.service';
import { PaacsbookingpopupComponent } from './views/pages/dbt/paacsbooking/paacsbookingpopup/paacsbookingpopup.component';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatStepperModule } from '@angular/material/stepper';
import { SelectProductComponent } from './views/pages/dbt/target/selectProduct/selectProduct.component';
import { PaccswisereportModule } from './views/pages/reports/paccswisereport/paccswisereport.module';
import { PaccsreportpopupModule } from './views/pages/reports/paccsreportpopup/paccsreportpopup.module';
import { PaccsdialyreportComponent } from './views/pages/reports/paccsdialyreport/paccsdialyreport.component';
import { PaccsuserModule } from './views/pages/master/paccsuser/paccsuser.module';
import { ShowtargetpopupComponent } from './views/pages/dbt/paacsbooking/showtargetpopup/showtargetpopup.component';
import { UpdatepricepopupComponent } from './views/pages/dbt/product/updatepricepopup/updatepricepopup.component';
import { MakkaludanmudhalvarschemecampreportComponent } from './views/pages/reports/makkaludanmudhalvarschemecampreport/makkaludanmudhalvarschemecampreport.component';
import { RemarksPopupComponent } from './views/pages/pvtmachinery/remarks-popup/remarks-popup.component';
import { ImplementRemarksPopupComponent } from './views/pages/pvtimplement/remarks-popup/remarks-popup.component';
import { ViewpvtbookingComponent } from './views/pages/pvtbooking/viewpvtbooking/viewpvtbooking.component';
import { DevicelogComponent } from './views/pages/reports/devicelog/devicelog.component';
import { MachinaryCategoryComponent } from './views/pages/master/machinary-category/machinary-category.component';
import { MachinaryCategoryassignComponent } from './views/pages/master/machinary-category/machinary-categoryassign/machinary-categoryassign.component';
import { MachinaryClasificationComponent } from './views/pages/master/machinary-clasification/machinary-clasification.component';
import { MachinaryClasificationassignComponent } from './views/pages/master/machinary-clasification/machinary-clasificationassign/machinary-clasificationassign.component';
import { PowerSourceComponent } from './views/pages/master/power-source/power-source.component';
import { PowerSourceComponentassignComponent } from './views/pages/master/power-source/power-source-componentassign/power-source-componentassign.component';
import { DbtProductSpecComponent } from './views/pages/master/dbt-product-spec/dbt-product-spec.component';
import { DbtProductSpecassignComponent } from './views/pages/master/dbt-product-spec/dbt-product-specassign/dbt-product-specassign.component';
import { AdminsendbackbookingComponent } from './views/pages/aeefarmerbookingapproval/adminsendbackbooking/adminsendbackbooking.component';
import { DbtproductComponent } from './views/pages/master/dbtproduct/dbtproduct.component';
import { DbtproductcomponentmappingComponent } from './views/pages/master/dbtproductcomponentmapping/dbtproductcomponentmapping.component';
import { DbtproductcomponentmappingModule } from './views/pages/master/dbtproductcomponentmapping/dbtproductcomponentmapping.module';
import { DbtproductcomponentmappingassignComponent } from './views/pages/master/dbtproductcomponentmapping/dbtproductcomponentmappingassign/dbtproductcomponentmappingassign.component';
import { TicketforwardusermappingComponent } from './views/pages/master/ticketforwardusermapping/ticketforwardusermapping.component';
import { TicketforwardusermappingModule } from './views/pages/master/ticketforwardusermapping/ticketforwardusermapping.module';
import { TicketforwardusermappingassignComponent } from './views/pages/master/ticketforwardusermapping/ticketforwardusermappingassign/ticketforwardusermappingassign.component';
import { GramapanchayatComponent } from './views/pages/master/gramapanchayat/gramapanchayat.component';
import { GramapanchayatsComponent } from './views/pages/master/gramapanchayat/gramapanchayats.component';
import { SmamdashboardpopupComponent } from './views/pages/smamdashboardpopup/smamdashboardpopup.component';
import { UserService } from './services/user.service';
import { PopupexeclService } from './services/popupexecl.service';
import { ShowutilizationreportsummaryComponent } from './views/pages/reports/showutilizationreportsummary/showutilizationreport.component';
import { SendBackDialogComponent } from './views/pages/farmerbookingdetails/send-back-dialog/send-back-dialog.component';
import { E2emechanizationService } from './services/e2emechanization.service';
import { FarmerdetailsComponent } from './views/pages/e2efarmmechanization/farmerdetails/farmerdetails.component';
import { PaacsbankdetailsComponent } from './views/pages/paacs/paacsbankdetails/paacsbankdetails.component';
import { ToggleMachImpleComponent } from './views/pages/Private EVaadagai/serviceprovider/toggle-mach-imple/toggle-mach-imple.component';
import { PaccsserviceprovidereditComponent } from './views/pages/Private EVaadagai/serviceprovider/paccsserviceprovideredit/paccsserviceprovideredit.component';
import { PaccsserviceprovidereditapprovalComponent } from './views/pages/Private EVaadagai/serviceprovider/paccsserviceprovidereditapproval/paccsserviceprovidereditapproval.component';
import { TicketingSystemComponent } from './views/pages/ticketing-system/ticketing-system.component';
import { AdministrativeMappingService } from './services/administrative-mapping.service';

import { PaccsduplicateComponent } from './views/pages/paccsduplicate/paccsduplicate.component';
import { RunLotteryComponent } from './views/pages/master/run-lottery/run-lottery.component';
import { LotteryDashboardComponent } from './views/pages/master/lottery-dashboard/lottery-dashboard.component';
import { LotteryReportComponent } from './views/pages/master/lottery-report/lottery-report.component';
import { LotteryReportPopupComponent } from './views/pages/master/lottery-report-popup/lottery-report-popup.component';
import { DbtDistrictWiseFlowProgressReportComponent } from './views/pages/master/dbtdistrictwiseflowprogressreport/dbtdistrictwiseflowprogressreport.component';
import { ManufacturerReportComponent } from './views/pages/master/manufacturerreport/manufacturerreport.component';
import { DbtDistrictWiseFlowProgressReportPopupComponent } from './views/pages/master/dbtdistrictwiseflowprogressreportpopup/dbtdistrictwiseflowprogressreportpopup.component';
import { DbtDivisionWiseFlowProgressReportComponent } from './views/pages/master/dbtdivisionwiseflowprogressreport/dbtdivisionwiseflowprogressreport.component';
import { DbtVillageWiseFlowProgressReportComponent } from './views/pages/master/dbtvillagewiseflowprogressreport/dbtvillagewiseflowprogressreport.component';
import { LotteryDivisionComponent } from './views/pages/master/lottery-division/lottery-division.component';
import { LotterySubdivisionComponent } from './views/pages/master/lottery-subdivision/lottery-subdivision.component';
import { LotteryVillageComponent } from './views/pages/master/lottery-village/lottery-village.component';
import { LotteryBeneficiaryListComponent } from './views/pages/master/lottery-beneficiary-list/lottery-beneficiary-list.component';
import { LotteryBookingDetailsComponent } from './views/pages/master/lottery-booking-details/lottery-booking-details.component';
import { LotteryDetailsComponent } from './views/pages/master/lottery-details/lottery-details.component';
import { UpdateAdditionalSubsidyComponent } from './views/pages/master/lottery-booking-details/update-additional-subsidy.component';
import { SubsidyPatternViewComponent } from './views/pages/master/subsidy-pattern-view/subsidy-pattern-view.component';
// import { LoaderModule } from './views/layout/loader/loader.module';
// import { MachineryWiseReportComponent } from './views/pages/reports/machinery-wise-report/machinery-wise-report.component';
// import { DivisionwithsubdivisionwiseprogressreportComponent } from './views/pages/reports/divisionwithsubdivisionwiseprogressreport/divisionwithsubdivisionwiseprogressreport.component';
// import { ShowsubdivisionreportComponent } from './views/pages/reports/showsubdivisionreport/showsubdivisionreport.component';
// import { DivisionwisereportComponent } from './views/pages/reports/divisionwisereport/divisionwisereport.component';
// import { SubdivisionwisereportComponent } from './views/pages/reports/subdivisionwisereport/subdivisionwisereport.component';
// import { DistrictwisereportComponent } from './views/pages/reports/districtwisereport/districtwisereport.component';
// import { VillagewisereportComponent } from './views/pages/reports/villagewisereport/villagewisereport.component';
// import { DbtbookingreportpopupComponent } from './views/pages/reports/dbtbookingreportpopup/dbtbookingreportpopup.component';
// import { TargetassignComponent } from './views/pages/master/targetassign/targetassign.component';
// import { AefarmerbookingapprovalComponent } from './views/pages/aefarmerbookingapproval/aefarmerbookingapproval.component';
// import { AefarmerbookingapprovalviewComponent } from './views/pages/aefarmerbookingapproval/aefarmerbookingapprovalview/aefarmerbookingapprovalview.component';

export function createTranslateLoader(http: HttpClient) {
  // return new TranslateHttpLoader(http, './assets/i18n/', '.json');
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    ViewpvtbookingComponent,
    FeedbackpopupComponent,
    AppComponent,
    ErrorPageComponent,
    ViewbookingComponent,
    ConsumableentrydialogComponent,
    RemittedtreasuryreportComponent,
    ShowremittedtreasuryreportComponent,
    ProductpopupComponent,
    ProductinfopopupComponent,
    ManufacturerpopupComponent,
    ManufacturerclarifypopupComponent,
    TreasuryremittedreportComponent,
    ShowtreasuryremittedreportComponent,
    UserfbDetailsComponent,
    TimelineComponent,
    ManufacturerDetailComponent,
    ToggleMachImpleComponent,
    UserfbTimelineComponent,
    AefarmerpaymentpopupComponent,
    ReturnAttachmentComponent,
    ManufacturerLockPopupComponent,
    UtilizationreportComponent,
    RealtimetrackingpopupComponent,
    ShowutilizationreportComponent,
    AeefarmerpopupComponent,
    DealerpremisesverificationpopupComponent,
    AeesendbackpopupComponent,
    SendbacktodealerpopupComponent,
    DealerrejectpopupComponent,
    ExemptionpopupComponent,
    DivisionlevelpopupComponent,
    SubdivisionlevelpopupComponent,
    VillagelevelpopupComponent,
    DivisionlevelDrillpopupComponent,
    SendbackpopupComponent,
    // ReviewreportComponent,
    BeneficiaryreportComponent,
    PaacsComponent,
    SelectProductComponent,
    PaacsbookingpopupComponent,
     ShowtargetpopupComponent,
     UpdatepricepopupComponent,
     MakkaludanmudhalvarschemecampreportComponent,
     RemarksPopupComponent,
     ImplementRemarksPopupComponent,
     DevicelogComponent,
     MachinaryCategoryComponent,
     MachinaryCategoryassignComponent,
     MachinaryClasificationComponent,
     MachinaryClasificationassignComponent,
     PowerSourceComponent,
     PowerSourceComponentassignComponent,
     DbtProductSpecComponent,
     DbtProductSpecassignComponent,
     AdminsendbackbookingComponent,
     DbtproductcomponentmappingassignComponent,
     DbtproductcomponentmappingComponent,
     TicketforwardusermappingComponent,
     TicketforwardusermappingassignComponent,
     SmamdashboardpopupComponent,
     ShowutilizationreportsummaryComponent,
     SendBackDialogComponent,
     FarmerdetailsComponent,
    //  PaacsbankdetailsComponent
     //GramapanchayatComponent,
     //GramapanchayatsComponent
    // ShowsubdivisionreportComponent,
    // SubdivisionwisereportComponent,
    // DistrictwisereportComponent,
    // VillagewisereportComponent,
    // DbtbookingreportpopupComponent,
    // TargetassignComponent,
    // AefarmerbookingapprovalComponent,
    // AefarmerbookingapprovalviewComponent,
    // FarmertimelineComponent,
    // BookingTimeLineComponent,
    // FarmertimelineComponent
    PaccsserviceprovidereditComponent,
    PaccsserviceprovidereditapprovalComponent,
    PaccsduplicateComponent,
    RunLotteryComponent,
    LotteryDashboardComponent,
    LotteryReportComponent,
    LotteryReportPopupComponent,
    DbtDistrictWiseFlowProgressReportComponent,
    DbtDistrictWiseFlowProgressReportPopupComponent,
    DbtVillageWiseFlowProgressReportComponent,
    DbtDivisionWiseFlowProgressReportComponent,
    ManufacturerReportComponent,
    LotteryDivisionComponent,
    LotterySubdivisionComponent,
    LotteryVillageComponent,
    LotteryBeneficiaryListComponent,
    LotteryBookingDetailsComponent,
    LotteryDetailsComponent,
    UpdateAdditionalSubsidyComponent,
    SubsidyPatternViewComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    SharedModule,
    ShowTripReportModule,
    ShowDailyReportModule,
    ShowWeeklyReportModule,
    MatDialogModule,
    FarmertimelineModule,
    aeefarmerPopupModule,
    subsidyReleaseToFarmerPopupModule,
    dealerPremisesVerificationPopupModule,
    ShowMonthlyReportModule,
    ShowOutturnReportModule,
    ShowBookingReportModule,
    ShowBillReportModule,
    eefarmerbookingpopupModule,
    ShowDistrictWiseStatusReportModule,
    MachineryWiseReportModule,
    WaitingListReportModule,
    PaccswisereportModule,
    PaccsreportpopupModule,
    PaccsuserModule,
    LayoutModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ManufacturerModule,
    ProductModule,
    MatButtonModule,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    MatInputModule,
    MatFormFieldModule,
    MatDialogModule,
    DirectivesModule,
    MatSelectModule,
    MatSelectFilterModule,
    MatDatepickerModule,
    MatMomentDateModule,
    MatNativeDateModule,
    MatTooltipModule,
    NgbDropdownModule,
    MatTabsModule,
    NgbModule,
    NgbCarouselModule,
    ArchwizardModule,
    //RouterModule.forChild(routes),
    MatIconModule,
    MatRadioModule,
    MatTreeModule,
    MatCheckboxModule,
    MatStepperModule,
    // LoaderModule,
    MatExpansionModule,
    NgMultiSelectDropDownModule.forRoot(),
    // PdfViewerModule,
    HttpClientModule,
    ToastrModule.forRoot({
      timeOut: 5000,
      positionClass: "toast-top-right",
      preventDuplicates: true,
    }),
    // NgHttpLoaderModule.forRoot(),
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: createTranslateLoader,
        deps: [HttpClient],
      },
    }),
    LightboxModule,
    UserIdleModule.forRoot({ idle: 1200, timeout: 20, ping: 30 }),
  ],
  providers: [
    AuthGuard,
    NavigationService,
    GenericValidator,
    LivetrackService,
    {
      provide: HIGHLIGHT_OPTIONS, // https://www.npmjs.com/package/ngx-highlightjs
      useValue: {
        coreLibraryLoader: () => import("highlight.js/lib/core"),
        languages: {
          xml: () => import("highlight.js/lib/languages/xml"),
          typescript: () => import("highlight.js/lib/languages/typescript"),
          scss: () => import("highlight.js/lib/languages/scss"),
        },
      },
    },
    DataService,
    AuthenticationService,
    AlertService,
    RoleService,
    ExcelService,
    ReportsService,
    UtilityService,
    hodashboardService,
    ManufacturerService,
    BlockService,
    UserSessionService,
    DepartmentBookingService,
    VehicleService,
    ProductService,
    DealerService,
    FarmerService,
    E2emechanizationService,
    UserService,
    PopupexeclService,
    AdministrativeMappingService,

    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { useUtc: false }},
    {provide: OWL_DATE_TIME_LOCALE, useValue: 'en-IN'},
    { provide: OWL_MOMENT_DATE_TIME_ADAPTER_OPTIONS, useValue: { useUtc: false } } ,
  ],
  bootstrap: [AppComponent],
  entryComponents: [],
})
export class AppModule {}
